module.exports = __webpack_public_path__ + "img/angle.fc1eb620.svg";